import { DashboardFlagsResponse, DashboardTodayResponse, JobToDateResponse } from '@siteday/shared';

import { api } from './client';

export const getToday = (date: string) =>
  api.get('/dashboard/today', DashboardTodayResponse, { date });
export const getJobToDate = (jobId: string) =>
  api.get(`/dashboard/jobs/${jobId}/to-date`, JobToDateResponse);
export const getFlags = (date: string) =>
  api.get('/dashboard/flags', DashboardFlagsResponse, { date });
